import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromAOM } from 'core/contexts/device-types';
import { SettingsDeviceTypesContainer } from 'modules/settings/pods/settings-devices/settings-devices-device-types/settings-devices-device-types.container';

export const SettingsDeviceTypesScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromAOM} source={DEVICE_TYPE_SOURCE.AOM}>
        <SettingsDeviceTypesContainer />
    </DeviceTypesProvider>
);

export default SettingsDeviceTypesScene;
